export default __webpack_public_path__ + "static/CactusJack-7fa54ddce5907b922ffd68d778c20938.woff";